/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';

import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as actions from '../../store/actions/index';

import messages from './AuditLogsTable.intl';

import JsonTreeModal from '../../components/JsonTreeModal/JsonTreeModal';

import EvtTable from '../../components/EvtTable/EvtTable';
import EvtFilter from '../../components/EvtFilter/EvtFilter';
import { filterPropertyTypes } from '../../utils/enums';

class AuditLogsTable extends Component {
    state = {
        activeTab: 0,
        showAuditLogModal: false,
        auditLog: {},
        filters: [],
        query: '',
    };

    reloadAuditLogsList = () => {
        const { query } = this.state;
        this.props.onInitAuditLogsCount(query);
        this.props.onInitAuditLogs(query);
    };

    handleAuditLogToggleModal = (auditLog) => {
        this.setState({
            showAuditLogModal: !this.state.showAuditLogModal,
            auditLog,
        });
    };

    handleFiltersChange = (filters) => {
        this.setState({
            filters,
        });
    };

    handleEvTableStateChange = (query) => {
        this.setState(
            {
                query,
            },
            () => {
                this.reloadAuditLogsList();
            },
        );
    };

    handleRefreshButtonClick = () => {
        this.reloadAuditLogsList();
    };

    handleGetTrProps = (state, rowInfo) => {
        return {
            style: {
                cursor: 'pointer',
            },
            onClick: () => this.handleAuditLogToggleModal(rowInfo.original),
        };
    };

    render() {
        const {
            intl,
            loadingAuditLogsList,
            auditLogs,
            auditLogsCount,
        } = this.props;
        const { filters } = this.state;

        const properties = [
            {
                key: 'createdBy',
                value: intl.formatMessage(messages.createdBy),
                type: filterPropertyTypes.TEXT,
            },
            {
                key: 'createdAt',
                value: intl.formatMessage(messages.createdAt),
                type: filterPropertyTypes.DATE,
            },
            {
                key: 'type',
                value: intl.formatMessage(messages.type),
                type: filterPropertyTypes.ENUM,
                enums: [
                    { key: 1, value: 'Add' },
                    { key: 2, value: 'Update' },
                    { key: 3, value: 'Delete' },
                    { key: 4, value: 'Error' },
                ],
            },
        ];

        const columns = [
            {
                Header: () => (
                    <div className='header-table-title'>
                        <span>{intl.formatMessage(messages.createdAt)}</span>
                    </div>
                ),
                accessor: 'createdAt',
                Cell: (row) => {
                    return new Date(row.value).toLocaleString(
                        navigator.language,
                    );
                },
            },
            {
                Header: () => (
                    <div className='header-table-title'>
                        <span>{intl.formatMessage(messages.createdBy)}</span>
                    </div>
                ),
                accessor: 'createdBy',
            },

            {
                Header: () => (
                    <div className='header-table-title'>
                        <span>{intl.formatMessage(messages.type)}</span>
                    </div>
                ),
                accessor: 'type',
                Cell: (row) => row.value,
            },
            {
                Header: () => (
                    <div className='header-table-title'>
                        <span>{intl.formatMessage(messages.message)}</span>
                    </div>
                ),
                accessor: 'message',
            },
        ];

        return (
            <>
                <header className='table-screen'>
                    <section className='title' />
                    <section className='btns-topo'>
                        <EvtFilter
                            properties={properties}
                            handleFiltersChange={this.handleFiltersChange}
                            loading={loadingAuditLogsList}
                        />
                        <button
                            className={`new-btn small ${
                                this.props.loadingAuditLogsList ? 'loading' : ''
                            }`}
                            onClick={this.handleRefreshButtonClick}
                        >
                            <FontAwesomeIcon icon='sync' size='1x' />
                        </button>
                    </section>
                </header>
                <EvtTable
                    filters={filters}
                    columns={columns}
                    data={auditLogs}
                    length={auditLogsCount}
                    pageSize={10}
                    handleStateChange={this.handleEvTableStateChange}
                    handleGetTrProps={this.handleGetTrProps}
                    loading={loadingAuditLogsList}
                    defaultSorted={[
                        {
                            id: 'createdAt',
                            desc: true,
                        },
                    ]}
                />
                <JsonTreeModal
                    isOpen={this.state.showAuditLogModal}
                    handleToggle={this.handleAuditLogToggleModal}
                    data={this.state.auditLog}
                    darkTheme={false}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auditLogs: state.logReducer.auditLogs || [],
        auditLogsCount: state.logReducer.auditLogsCount,
        loadingAuditLogsList: state.logReducer.loadingAuditLogsList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onInitAuditLogs: (filters) => dispatch(actions.initAuditLogs(filters)),
        onInitAuditLogsCount: (filters) =>
            dispatch(actions.initAuditLogsCount(filters)),
    };
};

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(AuditLogsTable),
);
